import { api } from '../../../lib/api.js';

export async function fetchNotifications() {
  const res = await api.get('notifications');
  return res.data;
}
